export default "__VITE_ASSET__DNLgcRPF__"